import DapDSTypography from './typography.component'

export * from './typography.component'
export default DapDSTypography

DapDSTypography.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-typography': DapDSTypography
  }
}
